<template>
    <div v-observe-visibility="visibilityChanged">
        <v-layout row justify-center>
            <v-dialog v-model="removeDialog" persistent max-width="350">
                <v-card>
                    <v-card-title class="headline">Delete item?</v-card-title>
                    <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
                        <v-btn color="primary darken-1" flat
                               @click.native="removeBranchOffice(branchOfficeToDelete)">OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm12 md6 lg3 pa-4 mt-3>
                <v-hover>
                    <v-card slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-flex xs12>
                            <v-flex xs12 pt-4 pb-3 pr-2 pl-4>
                                <span class="title">Branch Offices</span>
                            </v-flex>
                            <v-divider></v-divider>
                            <v-progress-linear class="branch-office-loading" :active="loading"
                                               :indeterminate="true"></v-progress-linear>
                        </v-flex>
                        <v-list class="branchOfficesList" two-line subheader>
                            <template v-for="(item, index) in supplierBranchOffices">
                                <v-list-tile ripple avatar
                                             @click="editBranchOffice(index)">
                                    <v-list-tile-avatar>
                                        <v-icon>business_center</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{item.name}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>{{item.city}} - {{item.zipcode}} - {{item.country}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon ripple @click="showDeleteBranchOfficeDialog(index)">
                                            <v-icon color="red lighten-1">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </template>
                        </v-list>
                        <v-flex v-if="supplierBranchOffices == null || supplierBranchOffices.length <= 0">
                            <v-card-text><p class="text-xs-center grey--text">No Branch Offices yet</p></v-card-text>
                        </v-flex>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn mt-5 dark color="secondary" @click="addNewBranchOffice">Add
                                <v-icon class="white--text" right>add</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-hover>
            </v-flex>

            <v-flex xs12 md12 lg9 pa-4 mt-3>

                <v-hover>
                    <v-card v-show="!formDisabled"
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 4 : 1}`">
                        <v-layout wrap>
                            <v-flex xs12 md4 pt-2 pl-4 pr-4>
                                <v-layout wrap>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">General</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedBranchOffice.name"
                                                      label="Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedBranchOffice.taxnumber"
                                                      label="Tax number">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md3 pt-2 pl-4 pr-4>
                                <v-layout wrap>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">Terms</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-flex xs12 pr-0>
                                            <v-autocomplete :disabled="formDisabled"
                                                            :items="termsOfDelivery"
                                                            item-text="name"
                                                            item-value="id"
                                                            label="Term of Delivery"
                                                            v-model="selectedBranchOffice.terms_of_deliveries_id"
                                                            required
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 pr-0>
                                            <v-autocomplete :disabled="formDisabled"
                                                            :items="termsOfPayment"
                                                            item-text="name"
                                                            item-value="id"
                                                            label="Term of Payment"
                                                            v-model="selectedBranchOffice.terms_of_payments_id"
                                                            required
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-flex>

                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md5 pt-2 pl-4 pr-4>
                                <v-layout wrap>
                                    <v-flex xs12 pt-3 pb-2>
                                        <span class="title">Address</span>
                                        <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex md8 xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedBranchOffice.street"
                                                      label="Street">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex offset-md1 md3 xs12>
                                        <v-text-field :disabled="formDisabled"
                                                      v-model="selectedBranchOffice.hnumber"
                                                      label="House number">
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-layout wrap>
                                            <v-flex xs4 pr-3>
                                                <v-text-field :disabled="formDisabled"
                                                              v-model="selectedBranchOffice.zipcode"
                                                              label="Postcode">
                                                </v-text-field>
                                            </v-flex>

                                            <v-flex xs8 pr-0>
                                                <v-text-field :disabled="formDisabled"
                                                              v-model="selectedBranchOffice.city"
                                                              label="City">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-autocomplete :disabled="formDisabled"
                                                        :items="countries"
                                                        label="Country"
                                                        v-model="selectedBranchOffice.country"
                                                        required
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-flex>


                        </v-layout>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                                   @click.native="saveBranchOfficeAndGoToNextTab(3)">Save
                                <v-icon class="white--text" right>save</v-icon>
                            </v-btn>
                        </v-card-actions>

                    </v-card>
                </v-hover>
  
            </v-flex>
        </v-layout>

    </div>
</template>


<script>
    import {Settings} from '../../../store/namespace-helper'

    export default {
      name: 'branch-offices',
      data () {
        return {
          countries: this.$store.getters.countries,
          isVisible: false,
          supplierBranchOffice: {},
          supplierContact: {},
          supplier_id: this.selectedSupplier,
          removeDialog: false,
          branchOfficeToDelete: null,
          onDismissed: false,
          branchOfficeUpdated: 0,
          formDisabled: true
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadSupplierBranchOffices()
              this.loadTermsOfPayments()
              this.loadTermsOfDeliveries()
            } else {
              this.formDisabled = true
              this.branchOfficeUpdated = 0
              this.$store.dispatch(Settings.actions.setSelectedBranchOffice, null)
              console.log('BranchOffices not visible!!!')
            }
          }
        },
        loadSupplierBranchOffices () {
          this.$store.dispatch(Settings.actions.loadSupplierBranchOffices, this.selectedSupplier.id)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        editBranchOffice (index) {
          this.formDisabled = false
          this.$store.dispatch(Settings.actions.setSelectedBranchOffice, this.supplierBranchOffices[index])
        },
        showDeleteBranchOfficeDialog (index) {
          this.removeDialog = true
          this.branchOfficeToDelete = index
        },
        removeBranchOffice (index) {
          this.removeDialog = false
          this.$store.dispatch(Settings.actions.removeBranchOffice, this.branchOfficeToDelete)
          this.branchOfficeUpdated = 0
          this.formDisabled = true
          this.selectedBranchOffice.name = ''
        },
        addNewBranchOffice () {
          let branchOffice = {
            id: null,
            name: 'New Branch Office',
            taxnumber: null,
            street: null,
            hnumber: null,
            city: null,
            zipcode: null,
            contry: null,
            suppliers_id: this.selectedSupplier.id,
            terms_of_deliveries_id: null,
            terms_of_payments_id: null
          }
          this.$store.dispatch(Settings.actions.addNewBranchOffice, branchOffice)
          this.$store.dispatch(Settings.actions.setSelectedBranchOffice, branchOffice)
        },
        saveBranchOfficeAndGoToNextTab (index) {
          this.$store.dispatch(Settings.actions.saveBranchOffices, this.supplierBranchOffices)
          this.branchOfficeUpdated = 0
        }

      },
      computed: {
        selectedSupplier () {
          return this.$store.getters[Settings.getters.getSelectedSupplier]
        },
        supplierBranchOffices () {
          return this.$store.getters[Settings.getters.getSupplierBranchOffices]
        },
        selectedBranchOffice () {
          return this.$store.getters[Settings.getters.getSelectedBranchOffice]
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        formEdited () {
          console.log('branch office formEdited: ' + this.branchOfficeUpdated)
          return this.branchOfficeUpdated < 2
        }
      },
      watch: {
        supplierBranchOffices: {
          handler (val) {
            console.log('supplierBranchOffices data changed: ' + JSON.stringify(val))
            this.branchOfficeUpdated++
          },
          deep: true
        }
      }
    }
</script>

<style scoped>
    .branchOfficesList {
        max-height: 50vh;
        overflow: scroll;
        margin-top: -20px;
    }

    .branchOfficesList::-webkit-scrollbar {
        display: none;
    }

    .branch-office-loading {
        margin-top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Settings/Suppliers/BranchOffices.vue